import scrollTo from '../utils/ScrollTo';
import CONF from '../utils/conf';
import u from '../utils/Utils';
import du from '../utils/dom-utilities';

/**
 * scrollDown - ScrollDown to main-content
 *
 * @param  {HTMLelement} [element=null] - DOM node which activate scroll down
 * @return {Set} - Scroll to main-content (#main)
 */
function scrollDown(element = null) {
    if (!element) {
        throw new Error('Element param cannot be null.');
    }

    let mainContent = document.querySelector('#main');
    let mainContentOffset = mainContent.getBoundingClientRect().top;

    element.addEventListener('click', (event) => {
        event.preventDefault();

        scrollTo(document.scrollingElement || document.documentElement, mainContentOffset, 400);
    });
}

/**
 * controlVideo - Control video state (play or pause)
 *
 * @param  {HTNLelement} [video=null] - video DOM Node
 * @param  {HTMLelement} [element=null] - video control DOM node
 * @return {Set} - Set video state play or pause
 */
function controlVideo(video = null, element = null) {
    if (!video || !element) {
        throw new Error('video param or element param cannot be null in controlVideo function.');
    }

    // Init video state
    setVideoState(video);


    // Add click event on video control
    element.addEventListener('click', (event) => {
        event.preventDefault();

        let currentVideoState = getVideoState(video);

        if (currentVideoState === 'paused') {
            setVideoState(video);
            updateVideoControl(element);
        } else {
            setVideoState(video, 'paused');
            updateVideoControl(element);
        }
    });
}

/**
 * getVideoState - return state of video param
 *
 * @param  {HTNLelement} [video=null] - Video DOM Node
 * @return {String} return paused of played based on current video state
 */
function getVideoState(video = null) {
    if (!video) {
        throw new Error('Video param cannot be null in getVideoState function.');
    }

    if (video.paused) {
        return 'paused';
    }

    return 'played';
}

/**
 * setVideoState - Update video state based on desired state passed in param
 *
 * @param {HTNLelement} [video=null] - Video DOM Node
 * @param {String} [state='played'] - desired video state
 * @return {Set} - set video state play of paused
 */
function setVideoState(video = null, state = 'played') {
    if (!video) {
        throw new Error('Video param cannot be null in setVideoState function.');
    }

    if (state === 'played') {
        video.play();
    } else {
        video.pause();
    }
}

/**
 * updateVideoControl - update video control class based on desired state
 *
 * @param  {HTMLElement} [element=null] - video control button
 * @return {[type]} toggle video control class
 */
function updateVideoControl(element = null) {
    if (!element) {
        throw new Error('Element param cannot be null in updateVideoControl function.');
    }

    if (element.classList.contains('hero__video-button--paused')) {
        element.classList.remove('hero__video-button--paused');
        element.classList.add('hero__video-button--played');
    } else {
        element.classList.remove('hero__video-button--played');
        element.classList.add('hero__video-button--paused');
    }
}

/**
 * Return a String template for the video
 * @param {String} poster
 * @param {String} video
 * @return {String}
 */
function videoTpl(poster='', video=''){
    return `<video poster="${poster}"
                style="opacity:0;transition:opacity 0.3s;" webkit-playsinline="true" playsinline="true"
                autoplay muted loop preload data-header-video-video>
                <source src="${video}" type="video/mp4">
            </video>`;
}

/**
 * Return a String template for the video control
 * @return {String}
 */
function controlTpl() {
    return `<button data-header-video-control class="hero__video-button hero__video-button--paused">
                <svg class="icon icon--paused"><use xlink:href="#round-pause"/></svg>
                <svg class="icon icon--played"><use xlink:href="#round-play"/></svg>
            </button>`;
}

/**
 * Insert video element on the given container and active polyfill
 * @param {HTMLElement} videoContainer The container of video
 * @return {HTMLElement} The video inserted
 */
function insertHeaderVideo(videoContainer){
    let videoTemplate = videoTpl(videoContainer.getAttribute('data-header-poster'),
            videoContainer.getAttribute('data-header-video'));
    videoContainer.insertAdjacentHTML('beforeend', videoTemplate);
    let video = videoContainer.querySelector('video');
    window.objectFitPolyfill(video);
    revealElement(video);
    return video;
}

/**
 * Insert video control on the given container
 * @param {HTMLElement} controlContainer
 * @return {HTMLElement} Inserted control
 */
function insertHeaderVideoControl(controlContainer) {
    controlContainer.insertAdjacentHTML('beforeend', controlTpl());
    return controlContainer.querySelector('[data-header-video-control]');
}

/**
 * Reveal the video elemnt only after few second when objectFit is polyfilled
 * To prevent visual bug of small video for browser don<t have objectFit support
 * @param {HTMLElement} video
 */
function revealElement(video){
    if ('objectFit' in document.documentElement.style !== false) {
        video.style.opacity = '1';
    } else {
        window.setTimeout(()=>{
            video.style.opacity = '1';
        },2000);
    }
}

/**
 * Insert video and controller nodes at min given size, otherwise remove it
 * @param {HTMLElement} videoContainer
 * @param {HTMLElement} controlContainer
 */
function toggleHeaderVideo(videoContainer, controlContainer){
    let video = videoContainer.querySelector('[data-header-video-video]');
    let videoControl = controlContainer.querySelector('[data-header-video-control]');
    if (Modernizr.mq(`(min-width: ${u.em(CONF.mq.smmin)}em)`)) {
        if (!video && !videoControl) {
            video = insertHeaderVideo(videoContainer);
            videoControl = insertHeaderVideoControl(controlContainer);
            controlVideo(video, videoControl);
        }
    } else if (video && videoControl) {
        videoContainer.removeChild(video);
        controlContainer.removeChild(videoControl);
    }
}

/**
 * Init the conditonal insert of video on header, and check on resize
 * @param {HTMLElement} videoContainer
 * @param {HTMLElement} controlContainer
 */
function initHeaderVideo(videoContainer, controlContainer) {
    toggleHeaderVideo(videoContainer, controlContainer);

    du.onEvent(window, 'optimized-resize', () => {
        toggleHeaderVideo(videoContainer, controlContainer);
    });
}

export {scrollDown, initHeaderVideo};



// WEBPACK FOOTER //
// ./src/main/js/components/header.js